import "moment-timezone";
import moment from "moment";

function parseDate(dateValue) {
  const timestamp = Number(dateValue);
  if (isNaN(timestamp)) {
    return moment.invalid();
  }
  const isUnix = timestamp < 1e12; 
  return isUnix ? moment.unix(timestamp) : moment(timestamp);
}

export const getPackageExpiry = (subscription) => {
  let differnce = 0;
  if (subscription?.amountPaid < 1 && subscription?.isValid) {
  } else if (!subscription?.isValid) {
    const endDate = parseDate(subscription?.endDate).tz("UTC");
    const diff = moment(moment().valueOf()).diff(endDate, "days");
    differnce = diff;
  }
  return differnce;
};
